module.exports = require("./zen-observable.js").Observable;
